interface MonksFlowIsotypeProps {
  className?: string;
  /** Names the mark for assistive tech. Omit where a sibling already labels it. */
  title?: string;
}

/**
 * The Monks.Flow mark, inline so it can follow the theme.
 *
 * It was authored for `currentColor` but shipped through `<img src>`, and an
 * `<img>`-referenced SVG is an isolated document: the custom property never
 * reached it, so it painted pure black and stayed there in dark mode. Inlining
 * is what makes `currentColor` mean anything, and it carries the mark's own
 * `role` and label into the accessibility tree, which an `<img alt>` replaced.
 */
export function MonksFlowIsotype(props: MonksFlowIsotypeProps) {
  return (
    <svg
      viewBox="0 0 40 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
      role={props.title ? 'img' : undefined}
      aria-label={props.title}
      aria-hidden={props.title ? undefined : true}
    >
      <path
        d="M25.1797 1.27539C29.017 1.27545 32.4316 2.27627 34.8516 4.05371C37.2381 5.80661 38.6962 8.33289 38.6963 11.583C38.6963 14.7675 37.1976 17.2546 34.7715 18.9883C32.3134 20.7447 28.8907 21.7246 25.1797 21.7246C21.4247 21.7246 18.003 20.7444 15.5576 18.9902C13.1451 17.2597 11.6631 14.7732 11.6631 11.583C11.6632 8.25449 13.1576 5.73103 15.5605 3.99805C18.0012 2.23793 21.4192 1.27539 25.1797 1.27539Z"
        stroke="currentColor"
        strokeWidth="2.55"
      />
      <path
        d="M14.792 1.27539C18.6293 1.27545 22.0439 2.27627 24.4639 4.05371C26.8504 5.80661 28.3085 8.33289 28.3086 11.583C28.3086 14.7675 26.8099 17.2546 24.3838 18.9883C21.9258 20.7447 18.503 21.7246 14.792 21.7246C11.037 21.7246 7.61534 20.7444 5.16992 18.9902C2.75741 17.2597 1.27539 14.7732 1.27539 11.583C1.27549 8.25449 2.76988 5.73103 5.17285 3.99805C7.61354 2.23793 11.0315 1.27539 14.792 1.27539Z"
        stroke="currentColor"
        strokeWidth="2.55"
      />
    </svg>
  );
}
